export const componentMap = {
    'App.Page.404': {name: 'solo-404', action: () => import('./modules/solo-404.js')},
    'App.Page.Product': {name: 'solo-products', action: () => import('./modules/Products/solo-products.js')},
    'App.Page.ElBank': {name: 'solo-eservices',
        action: () => import('./modules/Eservices/solo-eservices.js')},
    'App.Page.EventDetails': {
        name: 'solo-news-details',
        action: () => import('./modules/News/solo-news-details.js'),
        hasParams: true,
    },
    'App.Page.News': {name: 'solo-news', action: () => import('./modules/News/solo-news.js')},
    'App.Page.Lifestyle.Journals': {name: 'solo-lifestyle-journals',
        action: () => import('./modules/Lifestyle/solo-lifestyle-journals.js'),
    },
    'App.Page.Developers': {
      name: 'solo-developers',
      action: () => import('./modules/Developers/solo-developers.js'),
    },
    'App.Page.Developers.Detail': {
      name: 'solo-developers-details',
      action: () => import('./modules/Developers/solo-developers-details.js'),
      hasParams: true,
    },
    'App.Page.Investment': {
      name: 'solo-investment-page',
      action: () => import('./modules/Investment/solo-investment-page.js'),
    },
    'App.Page.ConsumerLoan': {
      name: 'solo-consumer-loan-application',
      action: () => import('./modules/Loans/ConsumerLoan/solo-consumer-loan-application.js'),
    },
    'App.Page.newBecomeSolo.Application': {
      name: 'solo-new-become-solo-application',
      action: () => import('./modules/newBecomeSolo/newBecomeSoloApplication/solo-new-become-solo-application.js'),
      hasParams: true,
    },
    'App.Page.KnowelegePage': {
      name: 'solo-knoweledge-page',
      action: () => import('./modules/KnoweledgeBasePage/solo-knoweledge-page.js'),
    },
    'App.Page.MainNew': {
      name: 'solo-main-new',
      action: () => import('./modules/MainPageNew/solo-main-new.js'),
    },
    'App.Page.LifestyleNew': {
      name: 'solo-lifestyle-new',
      action: () => import('./modules/LifestyleNew/solo-lifestyle-v2.js'),
    },
    'App.Page.EventsNew': {
      name: 'solo-events-new',
      action: () => import('./modules/LifestyleNew/solo-events-new.js'),
      hasParams: true,
    },
    'App.Page.EventsDetails': {
      name: 'solo-events-details',
      action: () => import('./modules/LifestyleNew/solo-events-details.js'),
      hasParams: true,
    },
    'App.Page.BankingLanding': {
      name: 'solo-banking-landing',
      action: () => import('./modules/Banking/Landing/solo-banking-landing.js'),
    },
    'App.Page.DebitCards': {
        name: 'solo-debit-cards',
        action: () => import('./modules/DebitCards/solo-debit-cards.js'),
    },
    'App.Page.Mortgage.Application': {
        name: 'solo-mortgage-application',
        action: () => import('./modules/Loans/Mortgage/MortgageApplication/solo-mortgage-application.js'),
    },
    'App.Page.CardsLanding': {
        name: 'solo-cards-landing',
        action: () => import('./modules/Cards/solo-cards-landing.js'),
    },
    'App.Page.CreditCards': {
      name: 'solo-credit-cards',
      action: () => import('./modules/CreditCards/solo-credit-cards.js'),
    },
    'App.Page.NonResidents': {
        name: 'solo-non-residents',
        action: () => import('./modules/NonResidents/solo-non-residents'),
    },
    'App.Page.SoloPackagesNew': {
      name: 'solo-packages-new',
      action: () => import('./modules/SoloPackages/solo-packages-new.js'),
      hasParams: true,
    },
    'App.Page.Loans': {
        name: 'solo-loans-new',
        action: () => import('./modules/newLoans/solo-loans-new.js'),
    },
    'App.Page.Loans.Auto': {
        name: 'solo-auto-loan-new',
        action: () => import('./modules/newLoans/solo-auto-loan-new'),
    },
    'App.Page.Loans.Ipo': {
        name: 'solo-ipo-loan-new',
        action: () => import('./modules/newLoans/solo-ipo-loan-new'),
    },
    'App.Page.Loans.Consumer': {
        name: 'solo-consumer-loan-new',
        action: () => import('./modules/newLoans/solo-consumer-loan-new'),
    },
    'App.Page.SoloReferralsApplication': {
      name: 'solo-referrals-application',
      action: () => import('./modules/SoloReferrals/InviteLinkApplication/solo-referrals-application.js'),
    },
    'App.Page.NewDeposits': {
        name: 'solo-new-deposits',
        action: () => import('./modules/NewDeposits/solo-new-deposits.js'),
        hasParams: true,
    },
    'App.Page.SoloReferrals.ReceiverApplication': {
        name: 'solo-referrals-receiver-application',
        action: () => import('./modules/SoloReferrals/ReceiverApplication/solo-referrals-receiver-application'),
        hasParams: true,
    },
    'App.Page.Application.OrderCard': {
      name: 'solo-card-application',
      action: () => import('./modules/OrderCard/solo-card-application.js'),
      hasParams: true,
    },
    'App.Page.carInsurance': {
        name: 'solo-car-insurance',
        action: () => import('./modules/Insurances/solo-car-insurance.js'),
    },
    'App.Page.travelInsurance': {
        name: 'solo-travel-insurance',
        action: () => import('./modules/Insurances/solo-travel-insurance.js'),
    },
    'App.Page.insuranceLanding': {
        name: 'solo-insurance-landing',
        action: () => import('./modules/Insurances/solo-insurance-landing'),
    },
    'App.Page.TravelInsurance.Application': {
        name: 'solo-travel-insurance-application',
        action: () => import('./modules/Insurances/Travel/solo-travel-insurance-application.js'),
    },
    'App.Page.cmsBuilder': {
        name: 'solo-cms-builder',
        action: () => import('./modules/cmsBuilder/solo-cms-builder.js'),
        hasParams: true,
    },
    'App.Page.MTPLInsurance.Application': {
        name: 'solo-mtpl-insurance-application',
        action: () => import('./modules/Insurances/MTPL/solo-mtpl-insurance-application'),
    },
    'App.Page.TravelsHub': {
        name: 'solo-travels-hub',
        action: () => import('./modules/TravelsHub/solo-travels-hub'),
    },
    'App.Page.NonResidentNew': {
        name: 'solo-non-resident-new',
        action: () => import('./modules/NonResidents/solo-non-resident-new'),
    },
    'App.Page.SoloReferralsWarningBanner': {
		    name: 'solo-referrals-warning-banner',
        action: () => import('./modules/SoloReferrals/solo-referrals-warning-banner.js'),
        hasParams: true,
    },
    'App.Page.ReferralMiddlePage': {
        name: 'solo-referral-middle-page',
        action: () => import('./modules/SoloReferrals/solo-referral-middle-page'),
        hasParams: true,
    },
};
